/* OURCHIVED scent quiz — result colour tagging. 2026-08-10.

   The quiz section (sections/ScentQuiz.liquid) is 30KB and carries the Klaviyo
   capture, so it is not rewritten. This script does one job: read the RESULT
   NAME the section renders and tag the quiz root with a data-scent attribute,
   so assets/ourchived-quiz.css can paint the scent colour.

   MATCHED BY NAME TEXT, not by index. The section picks a winner from four
   scent_N_name settings whose order is editable in the theme editor, and it
   falls through to the Discovery Set when answers are split. Reading the
   rendered name is the only order-proof hook.

   DISCOVERY GETS ALL FOUR, because Discovery is all four — the CSS leaves
   --strip as the four-segment gradient when no single scent matches, which is
   also the correct default for the START screen, where no result exists yet. */
(function () {
  if (window.__ohQuizScent) return;
  window.__ohQuizScent = true;

  var SCENTS = [
    { match: 'MIDNIGHT', key: 'bloom' },
    { match: 'JUST MY SKIN', key: 'skin' },
    { match: 'CODE BLUE', key: 'blue' },
    { match: 'LIQUID GOLD', key: 'gold' }
  ];

  function tag() {
    var root = document.querySelector('.oq');
    if (!root) return;

    var nameEl = root.querySelector('.oq__result-name');
    /* No result on screen yet — start screen or mid-quiz. Clear the tag so the
       four-segment default comes back if someone restarts. */
    if (!nameEl || !nameEl.offsetParent) {
      root.removeAttribute('data-scent');
      return;
    }

    var name = (nameEl.textContent || '').toUpperCase();
    for (var i = 0; i < SCENTS.length; i++) {
      if (name.indexOf(SCENTS[i].match) !== -1) {
        root.setAttribute('data-scent', SCENTS[i].key);
        return;
      }
    }
    /* Discovery, or anything unrecognised: all four. */
    root.setAttribute('data-scent', 'four');
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(tag, 120); }

  function init() {
    tag();
    var root = document.querySelector('.oq');
    if (!root) return;
    new MutationObserver(schedule).observe(root, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
